import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { id: "leaderboard-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", null, "Rank"),
    /*#__PURE__*/_createVNode("th", null, "Change"),
    /*#__PURE__*/_createVNode("th", null, "Page"),
    /*#__PURE__*/_createVNode("th", null, "Page Views")
  ])
], -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("td", null, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_leaderboard_row = _resolveComponent("leaderboard-row")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.articles.status !== 'error')
      ? (_openBlock(), _createBlock("table", _hoisted_2, [
          _hoisted_3,
          (_ctx.articles.status === 'okay')
            ? (_openBlock(), _createBlock("tbody", _hoisted_4, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.articles.data, (article, index) => {
                  return (_openBlock(), _createBlock(_component_leaderboard_row, {
                    key: index,
                    article: article
                  }, null, 8, ["article"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : (_openBlock(), _createBlock("tbody", _hoisted_5, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(new Array(100), (_, index) => {
                  return (_openBlock(), _createBlock("tr", { key: index }, [
                    _createVNode("td", null, _toDisplayString(index + 1), 1),
                    _hoisted_6,
                    _hoisted_7,
                    _hoisted_8
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}